import { useTranslation } from 'react-i18next';

import { areaExport, type AreaStatusFilter } from '@/api/domains/organization/areas';
import { useExport } from '@/hooks/ui/useExport';


export interface UseAreaExportParams {
  searchText?: string;
  status?: AreaStatusFilter;
}

interface UseAreaExportResult {
  exportAreas: () => Promise<void>;
  isExporting: boolean;
}

export function useAreaExport(params: UseAreaExportParams): UseAreaExportResult {
  const { t: translate } = useTranslation();

  const { onExport: exportAreas, isExporting } = useExport({
    exportFn: () => areaExport.export({
      searchText: params.searchText,
      status: params.status,
    }),
    successMessage: translate('organization:messages.exportSuccess'),
    errorMessage: translate('organization:messages.exportError'),
  });

  return { exportAreas, isExporting };
}
